/* omb-swatch-preview (2026-10-15, Zouhall)
   Hover a colour swatch (a[data-omb-sp]) for 150 ms: a floating card shows the big photo of that colour,
   its name and price. Mouse / trackpad only; keyboard focus-visible too. Touch screens: nothing runs.
   Data comes from Liquid (snippets/omb-swatch-preview-attrs.liquid): no API call. Image loaded on hover intent only. */
(function () {
  'use strict';
  var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var SEL = 'a[data-omb-sp]';
  var W = 300, GAP = 10, EDGE = 8, DELAY = 150;
  var card, box, img, nm, pr, cur = null, armed = null, timer = 0, loaded = {};

  function build() {
    if (card) return;
    var st = document.createElement('style');
    st.textContent =
      '.omb-sp{position:fixed;left:0;top:0;z-index:2147483000;width:' + W + 'px;background:#fff;border-radius:8px;' +
      'box-shadow:0 12px 32px rgba(0,0,0,.16),0 2px 6px rgba(0,0,0,.08);overflow:hidden;pointer-events:none;' +
      'opacity:0;transform:scale(.96);transition:opacity .15s ease-out,transform .15s ease-out;visibility:hidden}' +
      '.omb-sp.is-on{opacity:1;transform:none;visibility:visible}' +
      '.omb-sp__box{position:relative;background:#f4f4f4;max-height:60vh}' +
      '.omb-sp__box img{display:block;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .15s}' +
      '.omb-sp__box img.is-ld{opacity:1}' +
      '.omb-sp__meta{padding:10px 12px 12px;font-size:13px;line-height:1.35;color:#111;display:flex;justify-content:space-between;gap:10px;align-items:baseline}' +
      '.omb-sp__n{font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0}' +
      '.omb-sp__p{white-space:nowrap;flex:0 0 auto}' +
      '.omb-sp__p s{color:#8a8a8a;margin-right:6px}' +
      '.omb-sp__so{display:block;color:#8a8a8a;font-size:12px;text-align:right}' +
      '@media (prefers-reduced-motion:reduce){.omb-sp,.omb-sp__box img{transition:none;transform:none}}';
    document.head.appendChild(st);
    card = document.createElement('div');
    card.className = 'omb-sp';
    card.setAttribute('aria-hidden', 'true');
    card.innerHTML = '<div class="omb-sp__box"><img alt="" decoding="async"></div>' +
      '<div class="omb-sp__meta"><span class="omb-sp__n"></span><span class="omb-sp__p"></span></div>';
    box = card.firstChild; img = box.firstChild;
    nm = card.querySelector('.omb-sp__n'); pr = card.querySelector('.omb-sp__p');
    img.addEventListener('load', function () { img.classList.add('is-ld'); loaded[img.src] = 1; });
    document.body.appendChild(card);
  }

  function preload(a) {
    var u = a.getAttribute('data-omb-sp');
    if (u && !loaded[u]) { var i = new Image(); i.decoding = 'async'; i.onload = function () { loaded[u] = 1; }; i.src = u; }
  }

  function esc(s) { var d = document.createElement('span'); d.textContent = s || ''; return d.innerHTML; }

  function show(a) {
    if (!a.isConnected) return;
    build();
    cur = a;
    if (a.hasAttribute('title')) { a.setAttribute('data-omb-sp-t', a.getAttribute('title')); a.removeAttribute('title'); }
    var u = a.getAttribute('data-omb-sp');
    var r = parseFloat(a.getAttribute('data-omb-sp-r')) || 1;
    box.style.aspectRatio = String(r);
    if (img.getAttribute('src') !== u) { img.classList.remove('is-ld'); img.src = u; if (loaded[u] || img.complete) img.classList.add('is-ld'); }
    nm.textContent = a.getAttribute('data-omb-sp-n') || '';
    var c = a.getAttribute('data-omb-sp-c'), so = a.getAttribute('data-omb-sp-so');
    pr.innerHTML = (c ? '<s>' + esc(c) + '</s>' : '') + esc(a.getAttribute('data-omb-sp-p')) + (so ? '<span class="omb-sp__so">' + esc(so) + '</span>' : '');
    place(a);
    card.classList.add('is-on');
  }

  /* bottom of a sticky / fixed header at the top of the screen, so the card never sits under or over it */
  function safeTop(vw) {
    var top = EDGE, vh = window.innerHeight, hs = document.querySelectorAll('.shopify-section-group-header-group, header');
    for (var j = 0; j < hs.length; j++) {
      var hr = hs[j].getBoundingClientRect();
      if (hr.height > 0 && hr.bottom > 0 && hr.top < vh / 3) top = Math.max(top, hr.bottom + EDGE);
    }
    var els = document.elementsFromPoint ? document.elementsFromPoint(vw / 2, 2) : [];
    for (var i = 0; i < els.length && i < 12; i++) {
      for (var e = els[i]; e && e !== document.body; e = e.parentElement) {
        var p = getComputedStyle(e).position;
        if (p === 'fixed' || p === 'sticky') { top = Math.max(top, e.getBoundingClientRect().bottom + EDGE); break; }
      }
    }
    return top;
  }

  function place(a) {
    var rc = a.getBoundingClientRect(), vw = document.documentElement.clientWidth, vh = window.innerHeight;
    var h = card.offsetHeight, top = safeTop(vw);
    var x = Math.round(rc.left + rc.width / 2 - W / 2);
    x = Math.max(EDGE, Math.min(x, vw - W - EDGE));
    var y = rc.top - GAP - h, below = false;
    if (y < top) { y = rc.bottom + GAP; below = true; }
    if (below && y + h > vh - EDGE) {
      /* no room above or below: put it beside the swatch (left if possible), vertically clamped */
      below = false;
      x = rc.left - GAP - W >= EDGE ? rc.left - GAP - W : Math.min(rc.right + GAP, vw - W - EDGE);
      y = Math.max(top, Math.min(rc.top + rc.height / 2 - h / 2, vh - EDGE - h));
    }
    card.style.transformOrigin = Math.round(rc.left + rc.width / 2 - x) + 'px ' + (below ? '0' : '100%');
    card.style.left = x + 'px'; card.style.top = Math.round(y) + 'px';
  }

  function hide() {
    clearTimeout(timer); timer = 0; armed = null;
    if (cur && cur.hasAttribute('data-omb-sp-t')) { cur.setAttribute('title', cur.getAttribute('data-omb-sp-t')); cur.removeAttribute('data-omb-sp-t'); }
    cur = null;
    if (card) card.classList.remove('is-on');
  }

  function arm(a) {
    if (a === cur) return;
    hide();
    armed = a;
    preload(a);
    timer = setTimeout(function () { show(a); }, DELAY);
  }

  function find(t) { return t && t.closest ? t.closest(SEL) : null; }

  if (fine) {
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
      var a = find(e.target);
      if (a) arm(a);
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      var a = find(e.target);
      if (!a) return;
      if (e.relatedTarget && a.contains(e.relatedTarget)) return;
      if (a === cur || timer) hide();
    }, { passive: true });
    document.addEventListener('pointerdown', hide, { passive: true });
    window.addEventListener('scroll', function () {
      if (!armed) return;
      if (armed === document.activeElement) { if (cur) place(cur); return; } /* keyboard focus scrolled the page: follow it */
      hide();
    }, { passive: true });
  }
  /* keyboard: on any device with a keyboard, show on focus-visible */
  document.addEventListener('focusin', function (e) {
    var a = find(e.target);
    if (!a) return;
    try { if (!a.matches(':focus-visible')) return; } catch (x) { return; }
    arm(a);
  });
  document.addEventListener('focusout', function (e) { if (find(e.target)) hide(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  window.addEventListener('pagehide', hide);
})();
